import { NotificationEmptyBackground } from "./NotificationEmptyBackground";
import { useTranslation } from "react-i18next";

export const NotificationEmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-10 px-6">
      <NotificationEmptyBackground />
      <h3 className="mt-4 text-sm font-semibold text-gray-900">
        {t("You don't have any notifications")}
      </h3>
      <p className="mt-1 text-sm text-gray-500 text-center max-w-[260px]">
        {t("We'll notify you about important updates and any time you're mentioned.")}
      </p>
    </div>
  );
};
